<template>
  <div class="container">
    <TenantProfileMenu />

    <div class="grey-box-container">

      <h2>Assistant ({{ members.length }})</h2>
      <v-data-table :headers="headers" :items="members" must-sort hide-actions item-key="userId">
        <!-- There is always at least one admin, so no need to prepare for no-data -->
        <template slot="items" slot-scope="props">
          <tr @click="props.expanded = !props.expanded" class="pointer">
            <td>
              <img :src="props.item.profile.avatarUrl || require('../assets/placeholder-user.png')" class="user-avatar" />
              <div>{{ props.item.profile.firstName }} {{ props.item.profile.lastName || '(No name)' }}</div>
              <div><small>{{ props.item.profile.email }}</small></div>
            </td>
            <td>
              <TenantRoleIndicator :tenantRole="props.item.role" />
            </td>
            <td>
              <span v-if="props.item.profile.lastLogin">{{ props.item.profile.lastLogin | prettyDateShort }}</span>
              <span v-else>&mdash;</span>
            </td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <div class="clearfix padding-bottom">
            <div class="col12 padding">
              <ul>
                <li>
                  {{ props.item.profile.firstName || '' }} {{ props.item.profile.lastName || '' }}
                  ({{ props.item.role | lowercase | capitalize }})
                </li>
                <li><a :href="'mailto:' + props.item.profile.email">{{ props.item.profile.email || '' }}</a></li>
                <li>User ID: <tt>{{ props.item.userId }}</tt></li>
                <li>Created: {{ props.item.profile.created | prettyDateShort }}</li>
                <li>Last Login: {{ props.item.profile.lastLogin | prettyDateTime }}</li>
                <li>&nbsp;</li>
              </ul>
            </div>
            <div class="col12 padding padding-bottom align-right">
              <template v-if="props.item.userId !== userId">
                <p>
                  <button class="btn-danger btn-small" @click.prevent.stop="deleteTenantMember(props.item)"><v-icon dark>close</v-icon> Remove from Company</button><br/>
                  <small>Removed agent cannot anymore access or manage the auctions of this company.<br/>The user will still be listed as a listing agent of any existing auctions.</small><br/>
                </p>
                <p>
                  <button class="btn-small" @click.prevent.stop="changeRole(props.item, 'ASSISTANT')"><v-icon dark>security</v-icon> Change to Assistant</button>
                  <button class="btn-small" @click.prevent.stop="changeRole(props.item, 'AGENT')"><v-icon dark>security</v-icon> Change to Agent</button>
                  <button class="btn-small" @click.prevent.stop="changeRole(props.item, 'SUSPENDED')"><v-icon dark>block</v-icon> Suspend User</button><br/>
                  <small>Change role (Assistant or Agent) of the user, or temporarily suspend the access.</small><br/>
                </p>
              </template>
            </div>
          </div>
        </template>
      </v-data-table>
    </div>

    <div class="grey-box-container">
      <TenantMembersInvite :inviteRoleValue="inviteRole" />
    </div>

  </div>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'
  import TenantProfileMenu from './TenantProfileMenu.vue'
  import TenantMembersInvite from './TenantMembersInvite.vue'
  import TenantRoleIndicator from './elements/TenantRoleIndicator.vue'

  export default {
    name: 'TenantMembers',
    components: {
      TenantProfileMenu,
      TenantMembersInvite,
      TenantRoleIndicator
    },
    data() {
      return {
        auctions: [],
        members: [],
        inviteRole: 'ASSISTANT',
        headers: [
          { text: 'Name / Email', align: 'left', value: 'profile.firstName' },
          { text: 'Role', align: 'left', value: 'role' },
          { text: 'Last sign-in', align: 'left', value: 'profile.lastLogin'}
        ]
      }
    },
    computed: {
      ...mapGetters([
        'userId'
      ])
    },
    created() {
      this.loadTenantMembers()
    },
    methods: {

      ...mapMutations([
        'setLoadingSpinner',
        'openDialog'
      ]),

      deleteTenantMember(role) {
        this.setLoadingSpinner(true)
        this.$PfxBackendApi
          .deleteTenantRole(role)
          .then(() => {
            this.members = this.members.filter(i => {
              return i.userId !== role.userId
            })
          })
          .catch(err => {
            console.error('deleteTenantRole err', err)
            this.openDialog({
              title: 'Error',
              text: err.data.message,
              buttons: [{ title: 'Close this' }]
            })
          })
          .then(() => {
            this.setLoadingSpinner(false)
          })
      },

      changeRole(role, newRole) {
        this.setLoadingSpinner(true)
        this.$PfxBackendApi.changeTenantRole(role.userId, newRole).then(res => {
          Object.assign(role, res.data)
        }).catch(err => {
          console.error('changeTenantRole err', err)
          this.openDialog({
            title: 'Error',
            text: err.data.message,
            buttons: [{ title: 'Close this' }]
          })
        }).then(() => {
          this.setLoadingSpinner(false)
        })
      },

      loadTenantMembers() {
        this.setLoadingSpinner(2)

        this.$PfxBackendApi.getTenantAuctions().then(res => {
          console.log('getTenantAuctions res', res)
          this.auctions = res.data.data || []
        }).catch(err => {
          console.error('getTenantAuctions err', err)
        }).then(() => this.setLoadingSpinner('--'))

        this.$PfxBackendApi.getTenantMembers().then(res => {
          console.log('getTenantMembers res', res)
          res.data.map(member => {
            member.profile.fullName = `${member.profile.firstName||''} ${member.profile.lastName||''}`.trim()
          })
          this.members = res.data
          this.members = this.members.filter(function(member) {
            return member.role === 'ASSISTANT'
          })
          this.loading = false
        }).catch(err => {
          console.error('getTenantMembers err', err)
          this.openDialog({
            title: 'Error',
            text: err.data.message,
            buttons: [{ title: 'Close this' }]
          })
        }).then(() => this.setLoadingSpinner('--'))
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'node_modules/jeet/scss/index';

  .col12 { @include column(1/2); }

  .user-avatar {
    max-height: 24px;
    float: left;
    margin: 0.5em 1em 0.5em 0;
  }

  .padding {
    padding: 1em 1em 0;
  }
  .padding-bottom {
    padding-bottom: 1em;
  }

</style>



// WEBPACK FOOTER //
// src/components/TenantAssistant.vue